import { ScheduleContractSigningPageContent } from '../components/management/scheduleContractSigning/ScheduleContractSigningPageContent'

export const ScheduleContractSigningPage = () => {
  return <ScheduleContractSigningPageContent />
}
